interface Props {
    totalEmpresas: number;
    fechaInicio: string;
    fechaFin: string;
}

export function CounterPerDates({ totalEmpresas, fechaInicio, fechaFin }: Props) {
    return (
        <div className="h-full min-w-[205px] border border-gray-300 rounded p-2 bg-slate-100">
            <p className="text-center font-semibold text-lg">{totalEmpresas}</p>
            <p className="text-center font-semibold">Empresas registradas</p>
            <p className="text-center text-sm">del {fechaInicio} al {fechaFin}</p>
        </div>
    );
}